<template>
  <main>
    <Trail />
    <Container class="container--main">
      <Title tag="h1">Nuestro Equipo</Title>
      <p>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit. Optio
        quibusdam in hic facilis animi officia non labore debitis tempora?
        Cumque harum odio ullam animi ex omnis placeat saepe rem aspernatur.
      </p>
      <Row>
        <template v-for="(researcher, index) in researchers" :key="index">
          <ColumnUi md="4">
            <user-card
              :picture="researcher.picture"
              :name="researcher.name"
              :title="researcher.title"
              :scopus="researcher.scopus"
              :cti="researcher.cti"
              :orcid="researcher.orcid"
              :researcherId="researcher.id"
            />
          </ColumnUi>
        </template>
      </Row>
    </Container>
  </main>
</template>
<script>
import { getTeam } from "@/api/team.js";
import Container from "@/components/ui/objects/Container";
import Trail from "@/components/common/Trail";
import Title from "@/components/ui/atoms/Title.vue";
import UserCard from "@/components/ui/objects/UserCard.vue";
import Row from "@/components/ui/atoms/Row.vue";
import ColumnUi from "@/components/ui/atoms/ColumnUi.vue";

export default {
  components: {
    Container,
    Trail,
    Title,
    UserCard,
    Row,
    ColumnUi
  },
  setup() {
    const researchers = getTeam();
    return {
      researchers
    };
  }
};
</script>
